module.exports = __webpack_public_path__ + "img/commerceC.94ec777e.png";